/**
 * 相关接口文档
 * https://docs.qq.com/doc/DWUdMeFZXZmdxSHlG
 *
 * 平台管理、店铺管理、公司管理、客户管理、客户列表、客户黑名单
 * https://www.showdoc.com.cn/jh5e010200/8422986813549967
 * jh123456
 *
 * 品牌管理、类目管理、客户详情
 * https://www.showdoc.com.cn/1290839963426937/8428049275099019
 *
 * 商品管理、销售属性、商品属性库
 * https://www.showdoc.com.cn/5eck1201/8529976056830691
 * 123456
 *
 * 订单管理、客服订单、售后订单、物流订单、无订单支付、审核管理
 * https://www.showdoc.com.cn/1888265382452569/8644563693546610
 *
 */

import beforeApi from './modules/beforeApi.js'
import dataBoard from './modules/dataBoard.js' // 数据看板
import shortMessage from './modules/shortMessage.js'
import noteApi from './modules/noteApi.js'
import labelGroupApi from './modules/labelGroup.js' // 标签、人群
import matrixApi from './modules/matrixApi.js'
import templateAndShare from './modules/templateAndShare.js'

const apiFetch = Object.assign({}, beforeApi, dataBoard, shortMessage, noteApi, labelGroupApi, matrixApi, templateAndShare)
export default apiFetch
